import React from "react";

export const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@100..800&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght,FILL@100..700,0..1&display=swap');
    @import url('https://api.fontshare.com/v2/css?f[]=geist@1,200,300,400,500,600,700,800&display=swap');

    * { box-sizing: border-box; margin: 0; padding: 0; }
    html { scroll-behavior: smooth; }

    .glass-before::before {
      content: "";
      position: absolute;
      inset: 0;
      background: linear-gradient(135deg, rgba(255,255,255,0.12) 0%, transparent 40%);
      pointer-events: none;
      border-radius: inherit;
    }
    .material-symbols-outlined {
      font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
      vertical-align: middle;
    }
    .nav-link {
      font-family: 'Geist', sans-serif;
      font-size: 16px;
      font-weight: 400;
      text-decoration: none;
      transition: color 0.2s;
      padding-bottom: 4px;
      cursor: pointer;
      background: none;
      border: none;
    }
    .nav-link.active {
      font-weight: 700;
      border-bottom: 2px solid;
    }
    @keyframes ping {
      0%, 100% { transform: scale(1); opacity: 1; }
      50% { transform: scale(2); opacity: 0; }
    }
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.4; }
    }
    @keyframes fadeInUp {
      from { opacity: 0; transform: translateY(24px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    .fade-in { animation: fadeInUp 0.5s ease forwards; }
    .skill-bar { transition: width 1s ease; }
    input, textarea {
      outline: none;
      font-family: 'Geist', sans-serif;
    }
  `}</style>
);